import { WorkspaceRepositoryTable } from '@/components/workspace/WorkspaceRepositoryTable';

type Props = {
  workspaceId: number;
};

export const WorkspaceServicesSubPage = (props: Props) => {
  return <WorkspaceRepositoryTable workspaceId={props.workspaceId} />;
};
